import { GET_TAXRETURN, GET_STATS, ADD_TAXRETURN, UPDATE_TAXRETURN, TAXRETURN_LOADING, GET_TAXRETURN_BY_ID } from "../actions/types";

const initialState = {

  taxReturns: [],
  taxReturn: {},
  stats: {
    "archiveCount": 0,
    "unarchiveCount": 0,
    "revenue": 0,
    "clientCount": 0
  },
  loading: false

};


export default function (state = initialState, action) {
  switch (action.type) {
    case GET_TAXRETURN_BY_ID:
      return {
        ...state,
        taxReturn: action.payload,
        loading: false
      };
    case GET_TAXRETURN:
      return {
        ...state,
        taxReturns: action.payload,
        loading: false
      };
    case GET_STATS:
      return {
        ...state,
        stats: action.payload,
        loading: false
      };
    case ADD_TAXRETURN:
      return {
        ...state,
        taxReturns: [action.payload, ...state.taxReturns]
      };
    case UPDATE_TAXRETURN:
      return {
        ...state,
        taxReturns: [action.payload, ...state.taxReturns]
      };
    case TAXRETURN_LOADING:
      return {
        ...state,
        loading: true
      };


    default:
      return state;
  }
}
